<template>
  <div>
    <audio ref="audioPlayer" :src="audioUrl" preload="auto" muted autoplay type="audio/mp3" controls="false">
    </audio>
  </div>
</template>

<script>
export default {
  props: ["audioUrl"],
  mounted() {
    setTimeout(() => {
      this.$refs.audioPlayer.play();
    }, 500);
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/audio.vue